module.exports = __webpack_public_path__ + "static/media/huiyijiyaomoban.dfbfe921.png";